import { createRouter, createWebHistory } from 'vue-router'
import VueRouteMiddleware from 'vue-route-middleware'
import auth from '@/middleware/auth'
import authAdmin from '@/middleware/authAdmin'
import authTrainingAdmin from '@/middleware/authTrainingAdmin'
import authPhishingAdmin from '@/middleware/authPhishingAdmin'
import superadmin_auth from '@/middleware/authSuperAdmin'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'Main',
    component: () => import('../views/Main.vue'),
    redirect: 'dashboard',
    meta: {
      middleware: [auth],
      title: 'Core',
    },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Pages/Dashboard.vue'),
        meta: {
          title: 'Core',
        middleware: [authAdmin],
        },
      },
      {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: () => import('../views/Pages/NotFound'),
        meta: {
          title: 'Core',
        },
      },
    ],
  },
  // training routes
  {
    path: '/training',
    name: 'Training',
    redirect: '/training/assigned-training',
    component: () => import('../views/Main.vue'),
    meta: {
      middleware: [auth],
      title: 'Core',
    },
    children: [
      {
        path: 'assigned-training',
        name: 'AssignedTraining',
        component: () => import('../views/Pages/user/training/AssignedTraining.vue'),
      },
      {
        path: '/assigned-training/:id/quiz',
        name: 'QuizTraining',
        component: () => import('../views/Pages/user/training/Quiz.vue'),
      },
      {
        path: 'completed-training',
        name: 'CompletedTraining',
        component: () => import('../views/Pages/user/training/CompletedTraining.vue'),
      },
      {
        path: 'settings',
        name: 'UserLibrarySettings',
        meta: {
          title: 'Core',
          middleware: [authTrainingAdmin],
        },
        component: () => import('../views/Pages/user/training/Settings.vue'),
      },
      {
        path: 'settings/library/module/:id/quiz',
        alias: ['library/modules/:id/quiz', 'library/module/:id/quiz'],
        name: 'OrgModuleQuiz',
        meta: {
          title: 'Core',
          middleware: [authTrainingAdmin],
        },
        component: () => import('../views/Pages/admin/settings/library/Quiz.vue'),
      },
    ],
  },
   // phishing routes
   {
    path: '/phishing',
    name: 'Phishing',
    redirect: '/phishing/campaign-settings',
    component: () => import('../views/Main.vue'),
    meta: {
      middleware: [auth],
      title: 'Core',
    },
    children: [
      {
        path: 'campaign-settings',
        name: 'PhishingCampaignSettings',
        meta: {
          title: 'Core',
          middleware: [authPhishingAdmin],
        },
        component: () => import('../views/Pages/user/phishing/Settings.vue'),
      },
    ],
  },
   // policy routes
   {
    path: '/policy',
    name: 'Policy',
    redirect: '/phishing/campaign-settings',
    component: () => import('../views/Main.vue'),
    meta: {
      middleware: [auth],
      title: 'Core',
    },
    children: [
      {
        path: 'library',
        name: 'PolicyLibrary',
        component: () => import('../views/Pages/user/training/PolicyLibrary.vue'),
      },
      {
        path: 'compliance',
        name: 'PolicyCompliance',
        component: () => import('../views/Pages/user/training/PolicyCompliance.vue'),
      },
      {
        path: '/policy/view/:id',
        name: 'PolicyPreview',
        component: () => import('../components/policies/PolicyPreviewPage.vue'),
      },
    ],
  },
  // superadmin
  {
    path: '/admin/settings',
    name: 'Settings',
    redirect: '/admin/settings/scheduled-jobs',
    component: () => import('../views/Main.vue'),
    meta: {
      middleware: [superadmin_auth],
      title: 'Core',
    },
    children: [
      {
        path: 'scheduled-jobs',
        name: 'ScheduledJobs',
        component: () => import('../views/Pages/admin/settings/job/Index.vue'),
        meta: {
          title: 'Core',
          middleware: [superadmin_auth],
        },
      },
      {
        path: 'training-library',
        name: 'TrainingLibrary',
        component: () => import('../views/Pages/admin/settings/library/Index.vue'),
        meta: {
          title: 'Core',
          middleware: [superadmin_auth],
        },
      },
      {
        path: 'training-library/:id/quiz',
        name: 'SettingsQuiz',
        component: () => import('../views/Pages/admin/settings/library/Quiz.vue'),
        meta: {
          title: 'Core',
          middleware: [superadmin_auth],
        },
      },
      {
        path: 'training-library/:id/video',
        name: 'TrainingLibraryEdit',
        component: () => import('../views/Pages/admin/settings/library/Video.vue'),
        meta: {
          title: 'Core',
          middleware: [superadmin_auth],
        },
      },
      {
        path: 'phishing-configuration',
        name: 'Phishing Configuration',
        component: () => import('../views/Pages/admin/settings/phishing/Index.vue'),
        meta: {
          title: 'Core',
          middleware: [superadmin_auth],
        },
      },
    ],
  },
  {
    path: '/validation',
    name: 'Validation',
    component: () => import('../views/Validation'),
    meta: {
      title: 'Core',
    },
  },
]

if(typeof process.env.VUE_APP_DEPLOYMENT_ENV !== 'undefined' && (process.env.VUE_APP_DEPLOYMENT_ENV === 'local' || process.env.VUE_APP_DEPLOYMENT_ENV === 'development')) {

  // routes.push(
  //   {
  //     path: '/test',
  //     name: 'Test',
  //     component: () => import('../views/Test/Test.vue'),
  //     meta: {
  //       middleware: [authMiddleware],
  //       title: 'Vertex SOC',
  //     },
  //   },
  //   {
  //     path: '/test/mongodb',
  //     name: 'TestMongodb',
  //     component: () => import('../views/Test/Mongodb.vue'),
  //     meta: {
  //       middleware: [authMiddleware],
  //       title: 'Vertex SOC',
  //     },
  //   }
  // )
}


const router = createRouter({
  mode: 'history',
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to, from, next) => {
  try {
    const isValidationRoute = to.path.startsWith('/validation');

    // Prevent authenticated users from re-entering /validation without a new token on back navigation
    if (isValidationRoute && !to.query.access_token && store.state.auth.authenticated && store.state.auth.accessToken) {
      const isSuperAdmin = store.state.auth.isSuperAdmin;
      const isManager = store.state.auth.isManager;
      const destination = (isSuperAdmin || isManager) ? '/dashboard' : '/training/assigned-training';
      return next(destination);
    }

    await new Promise((resolve) => {
      VueRouteMiddleware({ auth })(to, from, resolve);
    });

    if (!isValidationRoute) {
      if (to.matched.length === 2 && to.matched[1].path.includes(':catchAll(.*)')) {
        localStorage.removeItem('currentUrl');
      } else {
        localStorage.setItem('currentUrl', to.fullPath);
      }
    }

    document.title = to.meta?.title || 'Core';
    next();
  } catch (error) {
    console.error('Navigation Error:', error);
    next();
  }
});

if (typeof window !== 'undefined') {
  const checkAuthOnBrowserNavigation = () => {
    try {
      const pathname = window.location.pathname || '';
      const currentRoutePath = router.currentRoute.value?.path || '';
      const isValidationRoute = pathname.startsWith('/validation') || currentRoutePath.startsWith('/validation');

      if (isValidationRoute) {
        // If already authenticated and navigating back to /validation without a token, redirect into the app
        const hasTokenInUrl = window.location.search && window.location.search.includes('access_token=');
        if (store.state.auth.authenticated && store.state.auth.accessToken && !hasTokenInUrl) {
          const isSuperAdmin = store.state.auth.isSuperAdmin;
          const isVertexAnalyst = store.state.auth.accessType === 'vertex_analyst';
          if (!isSuperAdmin && !isVertexAnalyst) {
            const org = store.state.user.organisation;
            const hasValidOrg = org && (org.organisation_id || org.id);
            if (!hasValidOrg) {
              return;
            }
          }
          const isManager = store.state.auth.isManager;
          const destination = (isSuperAdmin || isManager) ? '/dashboard' : '/training/assigned-training';
          router.replace(destination);
        }
        return;
      }

      if (!store.state.auth.authenticated || !store.state.auth.accessToken) {
        store.dispatch('auth/logout', { logoutAuth: false });
      }
    } catch (e) {
      console.error('Navigation auth check error:', e);
    }
  };

  window.addEventListener('pageshow', checkAuthOnBrowserNavigation);
  window.addEventListener('popstate', checkAuthOnBrowserNavigation);
}

export default router;